import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import LanguageSwitcher from "./LanguageSwitcher";
import logoicon from "SharedImages/tuutuum-logo-icon.png";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Header = () => {
  const { t, i18n } = useTranslation();
  const { loginToken, onLogout, userType } = useContext(AuthContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Stäng mobilmenyn vid sidbyte
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Logga ut och gå till startsida
  const handleLogout = () => {
    onLogout();
    navigate("/");
  };

  // Meny för inloggade användare
  const loggedInLinks = (
    <>
      {(userType === "PRINTER" ||
        userType === "ADMIN" ||
        userType === "SUPERUSER") && (
        <Link to="/printer" className="nav-link block">
          {t("page_printer")}
        </Link>
      )}
      {(userType === "ADMIN" || userType === "SUPERUSER") && (
        <Link to="/scans" className="nav-link block">
          {t("page_scans")}
        </Link>
      )}
      {(userType === "ADMIN" || userType === "SUPERUSER") && (
        <Link to="/user_admin" className="nav-link block">
          {t("page_user_admin")}
        </Link>
      )}
      {(userType === "ADMIN" || userType === "SUPERUSER") && (
        <Link to="/diseases" className="nav-link block">
          {t("page_diseases")}
        </Link>
      )}
      {(userType === "REGULAR" ||
        userType === "ADMIN" ||
        userType === "SUPERUSER") && (
        <Link to="/bearers" className="nav-link block">
          {t("page_bearers")}
        </Link>
      )}
      <Link to="/home" className="nav-link block">
        {t("page_home")}
      </Link>
      <button onClick={handleLogout} className="btn-secondary m-2 block">
        {t("page_sign_out")}
      </button>
    </>
  );

  // Meny för utloggade användare
  const loggedOutLinks = (
    <>
      <Link to="/invest" className="nav-link mr-5 block">
        {t("page_invest")}
      </Link>
      <Link to="/about" className="nav-link mr-5 block">
        {t("page_about")}
      </Link>
      <Link to="/contact" className="nav-link mr-5 block">
        {t("page_contact")}
      </Link>
      <Link to="/login" className="btn-main py-2 block">
        {t("login")}
      </Link>
    </>
  );

  return (
    <header>
      <div className="navbar">
        <nav className="bg-white w-full border-b border-primary-subtle border-opacity-50 shadow-p3 z-50 top-0">
          <div className="max-w-screen-2xl mx-auto px-4 py-2 md:py-1">
            <div className="flex items-center justify-between">
              <div className="flex-shrink-0 items-center w-auto justify-self-start px-0">
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <img
                    src={logoicon}
                    alt="Tuutuum Logo"
                    className="block h-8 w-auto transition ease-in-out hover:scale-90"
                  />
                </Link>
              </div>
              <div className="flex items-center justify-self-end">
                <div className="hidden md:block md:ml-6">
                  <div className="flex justify-center items-center font-bold uppercase text-base">
                    <LanguageSwitcher />
                    {loginToken ? loggedInLinks : loggedOutLinks}
                  </div>
                </div>
              </div>
              <div className="-mr-2 flex items-center md:hidden">
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  type="button"
                  className="-m-2.5 rounded-md p-2.5 text-gray-700"
                >
                  {mobileMenuOpen ? (
                    <XMarkIcon className="h-7 w-7" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="h-8 w-8" aria-hidden="true" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobilmeny */}
        {mobileMenuOpen && (
          <div className="flex flex-col text-center mobile-menu md:hidden">
            <div className="language-switcher items-end justify-end">
              <LanguageSwitcher />
            </div>
            <div className="text-lg space-y-1 uppercase font-bold mt-10">
              {loginToken ? (
                <>
                  {(userType === "PRINTER" ||
                    userType === "ADMIN" ||
                    userType === "SUPERUSER") && (
                    <Link
                      to="/printer"
                      className="nav-link block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {t("page_printer")}
                    </Link>
                  )}
                  {(userType === "ADMIN" || userType === "SUPERUSER") && (
                    <Link
                      to="/scans"
                      className="nav-link block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {t("page_scans")}
                    </Link>
                  )}
                  {(userType === "ADMIN" || userType === "SUPERUSER") && (
                    <Link
                      to="/user_admin"
                      className="nav-link block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {t("page_user_admin")}
                    </Link>
                  )}
                  {(userType === "ADMIN" || userType === "SUPERUSER") && (
                    <Link
                      to="/diseases"
                      className="nav-link block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {t("page_diseases")}
                    </Link>
                  )}
                  {(userType === "REGULAR" ||
                    userType === "ADMIN" ||
                    userType === "SUPERUSER") && (
                    <Link
                      to="/bearers"
                      className="nav-link block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {t("page_bearers")}
                    </Link>
                  )}
                  <Link
                    to="/home"
                    className="nav-link block"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {t("page_home")}
                  </Link>
                  <button
                    onClick={() => {
                      handleLogout();
                      setMobileMenuOpen(false);
                    }}
                    className="btn-secondary py-3 w-full uppercase block"
                  >
                    {t("page_sign_out")}
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/invest"
                    className="nav-link py-3 block"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {t("invest")}
                  </Link>
                  <Link
                    to="/login"
                    className="btn-main block"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {t("login")}
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
        <Outlet />
      </div>
    </header>
  );
};

export default Header;
